import React, {Fragment, useState, useContext, useEffect} from 'react'
import farmerContext from '../../../context/farmer/farmerContext'
import {useAlert} from "react-alert"


const ChangePassword = () => {

    const FarmerContext = useContext(farmerContext);
    const {updateFarmerPassword, farmer, clearAlert} = FarmerContext;
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const [user_data, setUser_data] = useState({
        //button loader for submit
        hide_spinner: "d-none",
        disable_button: false,

    })


    const {message} = farmer
    const alert = useAlert()
    useEffect(() => {
        if (message.msg !== "") {
            alert.show(
                message.msg, message.msg_options
            )
            clearAlert()
        }
        //eslint-disable-next-line
    }, [FarmerContext]);

    const onSubmit = e => {

        e.preventDefault()

        //button loader for submit
        setUser_data(prevState => ({
                ...prevState,
                disable_button: true,
                hide_spinner: " d-inline-block"
            })
        )

        let change_password_form = document.getElementById("change_password_form");
        let updated_operator_password = new FormData(change_password_form);
        updateFarmerPassword(updated_operator_password).then(res=>{
            setUser_data(prevState => ({
                    ...prevState,
                    disable_button: false,
                    hide_spinner: " d-none"
                })
            )
            change_password_form.reset();
        })

    }
    return (
        <Fragment>
            <div className="content-wrapper">
                <div className="container-fluid">

                    {/* <!--Start Dashboard Content--> */}

                    <div className="dashboard-inner-view">
                        <div className="row mt-3 justify-content-center">
                            <div className="col-lg-8">
                                <div className="profile-info-details">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <h3 className="make-bold">Password Settings</h3>
                                            <p>Update your password</p>
                                        </div>

                                        <div className="col-lg-6 card">
                                            <div className="card-body">
                                                <form onSubmit={onSubmit} id="change_password_form">
                                                    <div className="form-group mb-5">
                                                        <label>Current Password</label>
                                                        <div className="input-group mb-3">
                                                            <input type="password"
                                                                   className="form-control form-control-custom-view border-right-0"
                                                                   name="current_password"
                                                                   placeholder="Enter your current password"
                                                                   aria-label="Enter your current password"
                                                                   aria-describedby="basic-addon2"/>
                                                            <div className="input-group-append">
                                                                <span className="input-group-text bg-white"
                                                                      id="basic-addon2"><svg
                                                                    xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    className="feather feather-eye-off cursor-pointer small-icon"
                                                                    id="toggleVisibility">
                                                                        <path
                                                                            d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                                                                        </path>
                                                                        <line x1="1" y1="1" x2="23" y2="23"></line>
                                                                    </svg></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>New Password</label>
                                                        <input type="password"
                                                               name="new_password"
                                                               className="form-control form-control-custom-view"
                                                               placeholder="Enter your new password"/>
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Confirm New Password</label>
                                                        <input type="password" name="confirm_password"
                                                               className="form-control form-control-custom-view"
                                                               placeholder="Confirm your new password"/>
                                                    </div>
                                                    <div className="form-row justify-content-center mb-5">

                                                        <button type="submit"
                                                                className="btn btn-orange btn-custom-view btn-block
                                                                text-white d-flex justify-content-center align-items-center"
                                                                disabled={user_data.disable_button}>
                                                            Update Password
                                                            <i className="ml-1 fa fa-check" aria-hidden="true"> </i>
                                                            <span
                                                                className={"spinner-border spinner-border-sm ml-2 " + user_data.hide_spinner}
                                                                role="status"
                                                                aria-hidden="true">
                                                        </span>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="text-center mb-10 mb-lg-20">
                                                        <h4 className="make-bold mt-3">Profile Picture</h4>
                                                    </div>

                                                    <div className="form-group mt-5">
                                                        <img src={userInfo.passport}
                                                             className="rounded-circle img-fluid mx-auto d-block border"
                                                             style={{height: "200px", width: "200px"}}
                                                             alt="Equipment image"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!--End Dashboard Content--> */}

                </div>
                {/* <!-- End container-fluid--> */}

            </div>
            {/* End wrapper */}
        </Fragment>
    )
}

export default ChangePassword
